module.exports = __webpack_public_path__ + "media/images/manage-offer/edit-3c4acac6e38754cc2abad71262acf69f.png";